import './src/styles/global.css';
import React from 'react';
import Layout from './src/components/Layout';
import MicrositeLayout from './src/components/MicrositeLayout';
import { GatsbyBrowser } from 'gatsby';

export const wrapPageElement: GatsbyBrowser<any>['wrapPageElement'] = ({
  element,
  props,
}) => {
  return props.data.contentfulV2MicrositePage ? (
    <MicrositeLayout {...props}>{element as any}</MicrositeLayout>
  ) : (
    <Layout {...props}>{element as any}</Layout>
  );
};

// Track back/forward navigation directly.
let isHistoryPop = false;

export const onClientEntry: GatsbyBrowser['onClientEntry'] = () => {
  //add listener for popstate event
  window.addEventListener('popstate', () => {
    isHistoryPop = true;
  });
};

export const shouldUpdateScroll: GatsbyBrowser['shouldUpdateScroll'] = ({
  routerProps: { location },
  getSavedScrollPosition,
}) => {
  if (isHistoryPop) {
    const savedPosition = getSavedScrollPosition(location);
    window.scrollTo(...((savedPosition as [number, number]) || [0, 0]));
    return false;
  }
  // Get the anchor id from the location hash
  const anchorId = location.hash ? decodeURI(location.hash.slice(1)) : '';
  const anchor = anchorId ? document.getElementById(anchorId) : null;

  if (anchor) {
    anchor.scrollIntoView();
  } else {
    window.scrollTo(0, 0);
  }

  return false;
};

// Runs after shouldUpdateScroll, since RouteUpdates wraps the scroll handler.
export const onRouteUpdate: GatsbyBrowser['onRouteUpdate'] = () => {
  isHistoryPop = false;
};

// This replaces the default hydration function with a function that takes a container, created a root node from it and then attaches the child element.
// 1) https://www.gatsbyjs.com/docs/conceptual/react-hydration/#the-reactdomclienthydrateroot-method
// 2) https://www.gatsbyjs.com/docs/reference/config-files/gatsby-browser/#replaceHydrateFunction
// export const replaceHydrateFunction = () => {
//   return (element: React.ReactNode, container: ReactDOM.Container) => {
//     // Documentation around createRoot:  https://react.dev/reference/react-dom/client/createRoot
//     const root = ReactDOM.createRoot(container);
//     root.render(element);
//   };
// };
